<template>
    <div>
        <div class="left-toolbar mb10">
            <button @click="exportPdf" class="swb-btn-small swb-btn">导出为pdf</button>
        </div>
        <div id="payVoucherInfoPdf">
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">资产付款单</div>
            <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
                <tbody class="body">
                <tr class="row">
                    <td colspan="12" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: left;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                        <span>来源单据号：{{voucher.innerNo || '无'}}</span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                        <span>订购单位信息</span>
                    </td>
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                        <span>供应厂商</span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>公司名称：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.buyerName}}</div>
                        </div>
                    </td>
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;"><span>供方公司名称：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.sellerName}}</div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>公司地址：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.buyerAddr}}</div>
                        </div>
                    </td>
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>供方公司地址：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.sellerAddr}}</div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>公司税号：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.taxPayerNo}}</div>
                        </div>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 50px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>电话：</span>
                            </div>
                            <div class="value" style="padding-left: 50px;white-space: normal; word-break: break-all;">{{voucher.sellerContactTel}}</div>
                        </div>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>联系人：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.sellerContactName}}</div>
                        </div>
                    </td>

                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>联络人：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span>{{voucher.buyerContactName}}</span>
                            </div>
                        </div>
                    </td>
                    <td rowspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>付款信息：</span>
                            </div>
                        </div>
                    </td>
                    <td colspan="5" rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>银行账号：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.sellerAcctNo}}</div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                        <span>收货信息</span>
                    </td>
                </tr>

                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>收货店名：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span>{{voucher.buyerComName}}</span>
                            </div>
                        </div>
                    </td>

                    <td colspan="5" rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>开户行：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.sellerBankName}}</div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>收货人：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span>{{voucher.buyerComContactName}}</span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>电话：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span>{{voucher.buyerComContactTel}}</span>
                            </div>
                        </div>
                    </td>
                    <td colspan="5" rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>付款阶段：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{voucher.payPhaseName}}</div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>收货地址：</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span>{{voucher.buyerComAddr}}</span>
                            </div>
                        </div>
                    </td>
                </tr>

                <tr class="row">
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span>订单编号</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span>品名(项目)</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span>订购数量</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span>实收数量</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span>单价(元)</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span>税率(%)</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span>单位</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span>含税总计(元)</span>
                    </td>
                </tr>
                <tr class="row" v-for="(item,index) in voucher.itemList">
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span style="display: inline-block;">{{item.no}}</span>
                    </td>
                    <td colspan="3" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span style="display: inline-block;">{{item.title}}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span style="display: inline-block;">{{item.quantity}}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span style="display: inline-block;">{{item.revcQuantity}}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span style="display: inline-block;">{{(item.price || 0).toFixed(2)}}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span style="display: inline-block;">{{(item.taxRate || 0).toFixed(2)}}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span style="display: inline-block;">{{item.unit}}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-size: 14px;">
                        <span style="display: inline-block;">{{(item.amount || 0).toFixed(2)}}</span>
                    </td>
                </tr>
                <tr class="row">
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>订单未税金额(元)</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>{{(voucher.sumNtxAmount || 0).toFixed(2)}}</span>
                    </td>
                    <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>税金(元)</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>{{(voucher.sumAmount || 0).toFixed(2)}}</span>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>总计金额(含税)</span>
                    </td>
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>{{(voucher.amount || 0).toFixed(2)}}</span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="8" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>总&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;计(大写)</span>
                    </td>
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">{{voucher.amountCapital || ''}}</div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="8" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>已&nbsp;付&nbsp;金&nbsp;额(元)</span>
                    </td>
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>{{(voucher.amountPaid || 0).toFixed(2)}}</span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="8" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>未&nbsp;付&nbsp;金&nbsp;额(元)</span>
                    </td>
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>{{(voucher.amountOwed || 0).toFixed(2)}}</span>
                            </div>
                        </div>
                    </td>
                </tr>

                <tr class="row" v-if="voucher.payPhaseId != null">
                    <td colspan="8" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>&nbsp;&nbsp;本次付款阶段</span>
                    </td>
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>{{voucher.payPhaseName}}</span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row"><!-- v-if="voucher.payPhaseId != null"-->
                    <td colspan="8" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;font-size: 14px;">
                        <span>本次付款合计(元)&nbsp;</span>
                    </td>
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>{{(voucher.totalAmount || 0).toFixed(2)}}</span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td rowspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>备注</span>
                            </div>
                        </div>
                    </td>
                    <td colspan="11" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>制定人签字</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span></span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="11" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>审核人签字</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span></span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>核准</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span></span>
                            </div>
                        </div>
                    </td>
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>复核</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span></span>
                            </div>
                        </div>
                    </td>
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>财务签收</span>
                            </div>
                            <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                                <span></span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>附件信息</span>
                            </div>
                        </div>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>收货单</span>
                            </div>
                            <div class="value" style="padding-left:40px; margin-left: 5px; white-space: normal; word-break: break-all;">
                                <span style="display: inline-block;width: 14px;height: 14px;border: 2px solid #ddd;"></span>
                            </div>
                        </div>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>验收单</span>
                            </div>
                            <div class="value" style="padding-left:40px; margin-left: 5px; white-space: normal; word-break: break-all;">
                                <span style="display: inline-block;width: 14px;height: 14px;border: 2px solid #ddd;"></span>
                            </div>
                        </div>
                    </td>
                    <td colspan="4" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>发&nbsp;&nbsp;票</span>
                            </div>
                        </div>
                    </td>
                    <td colspan="2" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                        <div class="info-item " style="overflow:hidden;">
                            <div class="label" style="float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                                <span>收&nbsp;&nbsp;据</span>
                            </div>
                            <div class="value" style="padding-left:40px; margin-left: 5px; white-space: normal; word-break: break-all;">
                                <span style="display: inline-block;width: 14px;height: 14px;border: 2px solid #ddd;"></span>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import settleApi from '../../api/settle'
    import { showHtmlToPdfDlg } from '../ctrl/dialog'

    export default{
        name: 'swb-pay-voucher-info-pdf',
        desc: '支付单据导出',
        props: ['voucherId', 'payVoucherFlag'],
        data: function () {
            return {
                voucher: {},
            }
        },
        created: function () {
            this.getPayVoucherInfo();
        },
        methods: {
            getPayVoucherInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                postData.payVoucherFlag = self.payVoucherFlag;
                //
                let msgBoxDlg = MsgBox.loading();
                settleApi.doExportPayVouhcer(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let voucher = result.data;
                        let goodsItemList = voucher.goodsItemList || [];
                        let servcItemList = voucher.servcItemList || [];
                        let purchReceiptGoodsItems = voucher.purchReceiptGoodsItems || [];
                        let itemList = goodsItemList.concat(servcItemList);
                        if(!Utils.isNoB(purchReceiptGoodsItems) && purchReceiptGoodsItems.length > 0){
                            // 循环purchReceiptGoodsItems
                            for (let i = 0; i < purchReceiptGoodsItems.length; i++) {
                                let item = purchReceiptGoodsItems[i];
                                item.title = item.assetDefName;
                                item.quantity = item.quantity;
                                item.revcQuantity = item.quantity;
                                item.price = item.wtxPrice;
                                item.taxRate = item.taxRate;
                                item.unit = item.unit;
                                item.amount = item.wtxAmount;
                                itemList.push(item);
                            }
                        }
                        voucher.itemList = Utils.merge([], itemList);
                        self.voucher = voucher;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            exportPdf: function () {
                let result = $("#payVoucherInfoPdf").html() || '';
                showHtmlToPdfDlg("资产付款单", result, null);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/payment/PayVoucherInfoPdf.vue